export enum SELECT_NEGOTIATION_COLUMNS {
  CONTRACT = 'contract',
  COST_CENTER = 'cost-center',
  PRODUCT = 'product',
  BENEFIT = 'benefit',
  ANS = 'ans',
}
